import { Box, Text } from "@chakra-ui/react";
import ArrivalRatesPerHourTable from "../tables/ArrivalRatesPerHourTable";
import { ARRIVAL_RATES_FREQUENCIES } from "../../../store/constants";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../store/reportEnterpriseInsights";

const ArrivalRatesPerHour = ({ data, renderConfig, onRenderConfigChange }) => {
  return (
    <Box>
      {data.map((data, index) => {
        const { branchName, numServices } = data;
        const title = `${index + 1}. ${branchName}`;
        const insights = buildArrivalInsights(data, { scopeLabel: "Branch" });
        
        return (
          <Box key={index}>
            <h2>{title}</h2>
            <Text>{numServices} services</Text>
            <EnterpriseReportSummary
              title="Hourly Arrival Demand Summary"
              kpis={insights.kpis}
              tables={insights.tables}
              notes={insights.notes}
            />
            <ArrivalRatesPerHourTable
              data={data}
              index={index}
              frequency={ARRIVAL_RATES_FREQUENCIES.HOUR}
              renderConfig={renderConfig}
              onRenderConfigChange={onRenderConfigChange}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ArrivalRatesPerHour;
